<template>
    <main>
        <div class="container">{{ $t('profile') }}</div>
    </main>
</template>

<script>
export default {
    name: 'Profile',
};
</script>

<style lang="scss" scoped>
</style>
